export default __webpack_public_path__ + "static/media/left-arrows-couple.df4f547c.png";